<span>&raquo; {{name}}</span>